export default __webpack_public_path__ + "Revenue_Calculator_New_Product_Template_EU-zh-TW.10717920.xlsx";